module.exports = new Promise((resolve, reject) => {
          const rootUrl = eval('admin_app' + '_url'); // promise origin:spa_boclient

          if(!rootUrl || !window['admin_app' + '_url']){
            reject('admin_app')
            return;
          }
          const loadModule = (app) => {
            const proxy = {
              get: (request) => window[app].get(request),
              init: (arg) => {
                try {
                  return window[app].init(arg)
                } catch(e) {
                  console.warn('Remote container for ' + app + ' already initialized.')
                }
              }
            }
            resolve(proxy);
          };
          if (!rootUrl) {
            loadModule('aggregator_app');
            return;
          }
          const src = rootUrl + '/remoteEntry.js' + '?timestamp=' + '1792496087976';
          var relative = document.getElementsByTagName('script')[0];
          var script = document.createElement('script');

          Object.assign(script, {
            async: true,
            type: "text/javascript",
            src,
          });

          script.setAttribute("data-webpack", 'admin_app');
          relative.parentNode.insertBefore(script, relative);

          script.onload = () => {
            loadModule('admin_app');
          }

          script.onerror = () => {
            loadModule('aggregator_app');
          }
        }).catch((err) => {
          console.log(err, 'Error setting script tag for ' + admin_app);
        });